module.exports = __webpack_public_path__ + "static/media/chocolate.d81838f3.png";